import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withCookies } from "react-cookie";
import { Grid, Message } from "semantic-ui-react";
import "./assets/styles/main.css";
import "./assets/styles/print-media.css";
import {
  isTokenValid,
  expireSession,
  isUserLoggedIn,
  renewUserToken,
} from "./actions/auth";
import LoginPage from "./components/pages/LoginPage";
import ForgotPasswordPage from "./components/pages/ForgotPasswordPage";
import SearchOptions from "./components/pages/SearchOptions";
import UserRoute from "./components/routes/UserRoute";
import GuestRoute from "./components/routes/GuestRoute";
import QaRoute from "./components/routes/QaRoute";
import TopNavigation from "./components/navigation/TopNavigation";
import SearchRootComponent from "./components/searches/SearchRootComponent";
import SearchHistoryComponent from "./components/searches/SearchHistoryComponent";
import MySearches from "./components/myaccount/MySearches";
import MyCases from "./components/myaccount/MyCases";
import MyOfflineReports from "./components/myaccount/MyOfflineReports";
import OfflineCriminalSearch from "./components/myaccount/OfflineCriminalSearch";
import OfflineDriverLicenseSearch from "./components/myaccount/OfflineDriverLicenseSearch";
import MyCharges from "./components/myaccount/MyCharges";
import CreatePasswordPage from "./components/pages/CreatePasswordPage";
import { getAppFooter } from "./utils/PageHelper";

import AppRedirectPage from "./components/pages/AppRedirect";
import SecurityQuestionsCheck from "./components/pages/SecurityQuestionsCheck";
import SecurityTokenCheck from "./components/pages/SecurityTokenCheck";
import MyProfile from "./components/myaccount/MyProfile";

class App extends React.Component {
  constructor(props) {
    super(props);
    if (props.userAccount.acctTheme === 0)
      document.documentElement.classList.add("classic-theme");
  }

  componentDidMount() {
    const appReloadCount = !localStorage.appReloadCount ? 0 : localStorage.appReloadCount;
    const footer = document.getElementsByClassName('app-footer');
    if (!footer && appReloadCount < 3) {
      localStorage.appReloadCount = appReloadCount + 1;
      window.location.reload();
    }
    else {
      delete localStorage.appReloadCount;
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentWillReceiveProps(nextProps) {
    renewUserToken();
  }

  UserSecurityQuestions = () => <SecurityQuestionsCheck {...this.props} />;

  UserSecurityToken = () => <SecurityTokenCheck {...this.props} />;

  clearCache = () => {
    localStorage.clear();
    const pathName = this.props.location.pathname;
    if (!(pathName === "/" || pathName === "/login")) {
      localStorage.clear();
      setTimeout(
        window.location.href = "/login"
        , 1000);
    }
  }

  render() {
    const { location } = this.props;
    const pathName = this.props.location.pathname;
    if (!(pathName === "/" || pathName === "/login") && localStorage.appReloadCount === 3) {
      return (<div style={{ marginTop: "100px" }}> <Grid style={{ maringTop: " !important" }}><Grid.Row><Grid.Column width={4}>&nbsp;</Grid.Column>
        <Grid.Column width={8}>
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p className="remove-cache-warning">Please click <span role="button" tabIndex={-1} style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.clearCache()}>here</span> to restart the application.</p>
          </Message>
        </Grid.Column>
        <Grid.Column width={4}>&nbsp;</Grid.Column>
      </Grid.Row></Grid></div>);
    }
    return (
      <div id="uiRoot">
        <div className="ui">
          {this.props.isAuthenticated && <TopNavigation />}
          <GuestRoute
            location={location}
            path="/login"
            exact
            component={LoginPage}
          />
          <GuestRoute
            location={location}
            path="/forgotpassword"
            exact
            component={ForgotPasswordPage}
          />
          <GuestRoute
            location={location}
            path="/changepassword"
            exact
            component={ForgotPasswordPage}
          />
          <GuestRoute
            location={location}
            path="/createpassword"
            exact
            component={CreatePasswordPage}
          />
          <GuestRoute
            location={location}
            path="/createnewpassword"
            exact
            component={CreatePasswordPage}
          />
          <GuestRoute
            location={location}
            path="/appredirect/:sessionId"
            exact
            component={AppRedirectPage}
          />
          <QaRoute
            location={location}
            path="/securityquestions"
            exact
            component={this.UserSecurityQuestions}
          />
          <QaRoute
            location={location}
            path="/securitytoken"
            exact
            component={this.UserSecurityToken}
          />
          <UserRoute
            location={location}
            path="/"
            exact
            component={SearchOptions}
          />
          <UserRoute
            location={location}
            path="/searchoptions"
            exact
            component={SearchOptions}
          />
          <UserRoute
            location={location}
            path="/MainTabs"
            exact
            component={SearchOptions}
          />
          <UserRoute
            location={location}
            path="/My Account/My Cases"
            exact
            component={MyCases}
          />
          <UserRoute
            location={location}
            path="/My Account/My Searches"
            exact
            component={MySearches}
          />
          <UserRoute
            location={location}
            path="/My Account/My Offline Reports"
            exact
            component={MyOfflineReports}
          />
          {this.props.userAccount.acctMasterUser === "1" && (
            <UserRoute
              location={location}
              path="/My Account/My Charges"
              exact
              component={MyCharges}
            />
          )}
          <UserRoute
            location={location}
            path="/My Account/My Profile"
            exact
            component={MyProfile}
          />
          <UserRoute
            location={location}
            path="/search/history"
            exact
            component={SearchHistoryComponent}
          />
          <UserRoute
            location={location}
            path="/offline/criminalsearch"
            exact
            component={OfflineCriminalSearch}
          />
          <UserRoute
            location={location}
            path="/offline/dlsearch"
            exact
            component={OfflineDriverLicenseSearch}
          />
          <UserRoute
            location={location}
            path="/search/:category/:groupType/:searchType/:reportId"
            exact
            component={SearchRootComponent}
          />
          <UserRoute
            location={location}
            path="/search/:category/:groupType"
            exact
            component={SearchRootComponent}
          />
        </div>
        {getAppFooter()}
      </div>
    );
  }
}

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    userid: state.user && state.user.userid,
    isAuthenticated: !!state.user.token,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  isTokenValid,
  expireSession,
  isUserLoggedIn,
})(withCookies(App));



// WEBPACK FOOTER //
// ./src/App.js